<template>
  <section class="vbox">
    <section class="scrollable padder">
      <section class="row m-b-md brud-theme">
        <div class="col-sm-6 text-black">
          <ol class="breadcrumb text-left">
            <li>
              <a href="#"><i class="fa fa-dashboard"></i> Home</a>
            </li>
            <li class="active">Product List</li>
          </ol>
        </div>
        <div class="col-sm-6 text-right text-left m-t-sm">
          <small> </small>
        </div>
      </section>

      <section class="panel panel-default">
        <header class="panel-heading">
          <div class="row">
            <div class="col-sm-12">
              <h4>
                <i class="fa fa-list-ul"></i>
                Product List
              </h4>
            </div>
          </div>
        </header>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6">
              <select
            class="form-control"
            v-model="category"
            name="category_id"
            style="width: 100%;"
            @change="refreshTable"
          >
            <option id="category" selected value=""
              >Choose Category</option
            >
            <option
              v-for="category in categoryList"
              :key="category.category_id"
              v-bind:value="category.category_id"
              >{{ category.category_name }}</option
            >
          </select>
            </div>
            <div class="col-md-6">
                  <select
                    class="form-control"
                    v-model="brand"
                    name="brand_id"
                    style="width: 100%;"
                  >
                    <option id="brand" selected value=""
                      >Choose Brand</option
                    >
                    <option
                      v-for="brand in brandList"
                      :key="brand.brand_id"
                      v-bind:value="brand.brand_id"
                      >{{ brand.brand_name }}</option
                    >
                  </select>
            </div>
          </div>
          <hr/>
          
            <div class="co-md-12">
                <b-table id="item-table"
                  :items="filteredList" 
                  ref="table"
                  primary-key="product_id"
                  :fields="fields"
                  @filtered="onFiltered"
                  hover
                  :per-page="perPage"
                  :current-page="currentPage">
                  <!-- A virtual column -->
                  <template #cell(sno)="data">
                    {{ (currentPage - 1) * perPage + data.index + 1 }}
                  </template>
                </b-table>
              <!-- Show pagination links -->
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  aria-controls="item-table"
                  hide-ellipsis
                  ></b-pagination>
                <json-excel 
                  class="btn btn-success"
                  style="float: right;"
                  :data="filteredList"
                  :fields="exportFields"
                  name="product-list.xls"
                  >
                  Export
                </json-excel>
            </div>
        </div>
      </section>
    </section>
  </section>
</template>

<script>

import api from "../api";
import { BTable, BPagination } from 'bootstrap-vue'
import JsonExcel from "vue-json-excel";

export default {
  name: "ProductList",

  components: {
    BPagination,
    BTable,
    JsonExcel
  },
  data() {
    return {
      isBusy: false,
      categoryList: [],
      category: "",
      brand: "",
      brandList: [],
      itemList: [],
      perPage: 10,
      currentPage: 1,
      filteredCount: 1,
      fields: [
        { key:'sno', label: '#'},
        { key:'product_name', label: 'Product'},
        { key:'brand_name', label: 'brand'},
        { key:'category_name', label: 'Category'},
        { key:'uom_name', label: 'Unit of Measure'},
        ],
      exportFields: {
        'Product Name': 'product_name',
        'Brand': 'brand_name',
        'Category': 'category_name',
        'Unit of Measure': 'uom_name',
        'Price': 'price'
      }
    };
  },
  computed: {
    filteredList: function () {
     const list = this.itemList.filter((item) => {
       const categoryFilter = this.category ? item.category_id == this.category : true
       const brandFilter = this.brand ? item.brand_id == this.brand : true
       return categoryFilter && brandFilter
     });
     return list
    },
    totalRows: function () {
      return this.filter && this.filter.length ? this.filteredCount : this.filteredList.length
    }
  },
  methods: {
    refreshTable: function () {
      this.$refs.table.refresh()
    },
    getBrands: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_brands", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.brandList = [];
          } else {
            this.brandList = data.brandList;
          }
        });
    },
    getCategory: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_category", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            if (data.errorcode === 25000) {
              this.$router.push('/login')
            }
            this.categoryList = response.data.values;
          } else {
            this.categoryList = data.categoryList;
          }
        });
    },
    itemProvider() {
      let items = []
      const list = {
        filter: {
          'product_name': this.productName
        },
      };
      api
        .request("post", "GeneralApis/get_products", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.itemList = response.data.values;
          } else {
            this.itemList = data.productList;
            items = this.itemList
            // this.totalRows = this.itemList.length
            // this.$refs.table.refresh();
            return data.productList;
          }
        });
      return items || []
    },
    getList: function() {
      const list = {
        filter: {
          'product_name': this.productName
        },
      };
      api
        .request("post", "GeneralApis/get_products", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            if (data.errorcode === 25000) {
              this.$router.push('/login')
            }
            this.itemList = response.data.values;
          } else {
            this.itemList = data.productList;
           // this.totalRows = this.itemList.length
          }
        });
    },
    showForm: function(productid) {
      this.itemId = productid;
      this.showFormModal = true;
    },
    deleteProduct(productId) {
      const formData = {
        "product-form": {
          product_id: productId
        },
      };
      api
        .request("post", "GeneralApis/change_product_status", formData)
        .then((response) => {
          var data = response.data;
          if (data.errorcode) {
            this.response = data.errormessage;
            return;
          } else {
            alert("Item Deleted Successfully!");
            this.itemList = data.productList;
          }
        });
    },
      onFiltered(filteredItems) {
        this.filteredCount = filteredItems.length
        this.currentPage = 1
      }
  },
  mounted(){
    this.getList()
    this.getCategory();
    this.getBrands()
  }
};
</script>
